import { makeStyles } from "@material-ui/core/styles";
import { Breadcrumb } from 'antd';
import navBarStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import titleStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle";
import cardStyles from "assets/jss/material-dashboard-pro-react/components/cardStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import Card from "components/Card/Card.js";
import CardFooter from "components/Card/CardFooter";
import CardHeader from "components/Card/CardHeader.js";
import CardBody   from "components/Card/CardBody.js"
import Button from "components/CustomButtons/Button.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchLevels } from '../../../../../reduxToolkit/features/level/LevelSlice';
import { fetchAreas} from 'reduxToolkit/features/area/AreaSpecSlice';

import DropDownLevelButton from "../../../../Components/DropDownLevelButton";


const useStyles = makeStyles(styles);
const useNavBarStyles = makeStyles(navBarStyles);
const useTitleStyles = makeStyles(titleStyles);
const useCardStyles = makeStyles(cardStyles);
// const usePagesHeaderstyle = makeStyles(pagesHeaderstyle);


const LevelExcerpt = ({ level }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const cardClasses = useCardStyles();
  const areas = useSelector(state => state.areaSpec.areas)
  const listAreaSpec  = areas?.filter(({id})=>level.areaSpec_ids.includes(id)).map(({name})=> name).join(', ')

  return (

    <GridItem xs={12} sm={12} md={4} key={level.id} >
      <Card style={{ maxWidth: "380px", minWidth: "380px", maxHeight: "180px", minHeight: "180px" }} cardHover >
        <CardHeader>
          <GridContainer direction="row"
            justifyContent="space-between"
            alignItems="baseline">
            <GridItem xs={10} sm={10} md={10}>
              <h4 className={cardClasses.cardProductTitle}>
                {level.name}
              </h4>
         
            </GridItem>
            <GridItem xs={2} sm={2} md={2}>
              <DropDownLevelButton id={level.id} />
            </GridItem>
          </GridContainer>
        </CardHeader>
        <CardBody style={{marginTop:'-15px'}} smallCardBody>
        
           {listAreaSpec && `Tag: ${level?.tag}`}<br/>
           {listAreaSpec && `Area: ${listAreaSpec}`}

          {/* <div style={{ color: `${primaryColor[0]}`, fontWeight: "bold" }}> Departments:
            {program.department_detail && program.department_detail.map((department) => {
              return <div style={{ fontWeight: "normal" }}> {department.name} </div>

            }
            )}
          </div> */}


        </CardBody>
        <CardFooter>
          <GridContainer
            direction="row"
            justify="flex-end"
            alignItems="center">
            {/* <GridItem> <span style={{ color: (program.state) === "Draft" ? grayColor[1] : "#FFCB3B" }}>{program.state}</span> </GridItem> */}
          </GridContainer>
        </CardFooter>
      </Card>
    </GridItem>
  )
}

export default function Levels() {
  const [search, setSearch] = useState("")
  const { t } = useTranslation();
  const classes = useStyles();
  const navBarClasses = useNavBarStyles();
  const titleClasses = useTitleStyles();
  // const headerClasses = usePagesHeaderstyle();
  // console.log('token', token)


  const dispatch = useDispatch()

  const levelsStatus = useSelector(state => state.level.levelsStatus)
  useEffect(() => {
    if (levelsStatus === 'idle') {
      dispatch(fetchLevels())
    }
    dispatch((fetchAreas()))

  }, [
    levelsStatus,
    dispatch])

  const levels = useSelector(state => state.level.levels)
  const error = useSelector(state => state.level.error)
  console.log(levels, "levels")
  let content

  const searchButton =
    navBarClasses.top +
    " " +
    navBarClasses.searchButton

  if (levelsStatus === 'loading') {
    content = <div className="loader">{t('Loading...')}</div>
  } else if (levelsStatus === 'succeeded') {
    content = levels && levels.filter((level) => {
      if (search == '') {
        return level
      } else if (level.name.toLowerCase().includes(search.toLowerCase())) {
        return level
      }
    }).map(level => (
      <LevelExcerpt key={level.id} level={level} />
    ))
  } else if (levelsStatus === 'failed') {
    content = <div>{error}</div>
  }
  return (
    <div>
      <GridContainer

        md={12}
        xs={12} sm={12}
        direction="row"
        // style={{ width:300 ,height:150}}
        justify="space-between"
        alignItems="center"
      >
        <GridItem>

          <Breadcrumb separator=">">
            <Breadcrumb.Item >

              {t('Configurations')}

            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/configuration/course`}>
                <span > {t('Course Configurations')} </span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/configuration/course/level`}>
                <span > {t('Levels')} </span>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </GridItem>

      </GridContainer>


      <GridContainer
        justify="space-between"
        alignItems="center">
        <GridItem>
          <Link to="/citrine/configuration/course/level/createLevel/:id">
            <Button color="primary">
              {t('Add')}
            </Button>
          </Link>
        </GridItem>

      </GridContainer>

      <GridContainer >
        {content}
      </GridContainer>
      {/* <Link to={"/citrine/programs/test"} >
    <p>here</p>
    </Link> */}
    </div>
  );
}













